import passwordRegex from '@eneco/common/validation/passwordRegex';
import * as yup from 'yup';


export const registerOrgPasswordSchema = yup.object({
  password: yup.string().required('passwordRequired').matches(passwordRegex, 'passwordInvalid'),
});
